export default "__VITE_ASSET__BOzTyYi1__"